/* eslint no-alert: 0 */

export default {
  alert: message => window.alert(message),
  confirm: (_, message, buttons) => window.confirm(message) && buttons[1].onPress(),
};
